import { useInfiniteQuery } from '@tanstack/react-query';

import UsersService, { type AccountIdentityActivityLog } from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

/**
 * Pages through one identity's sign-in history, starting from the first page that
 * useGetAccountIdentityActivityLogs already loaded. Every fetch is audited as a view of the user's
 * data, so the first page is never refetched.
 */
export function useGetIdentityActivityEvents(accountId: string, firstPage: AccountIdentityActivityLog) {
  return useInfiniteQuery({
    queryKey: usersQueryKeys.identityActivityEvents(accountId, firstPage.identity_id),
    queryFn: async ({ signal, pageParam }) => {
      const [page] = await UsersService.getAccountIdentityActivity(accountId, {
        identityId: firstPage.identity_id,
        nextToken: pageParam,
        signal,
      });
      return page ?? { ...firstPage, events: [], next_token: null };
    },
    initialPageParam: undefined,
    initialData: { pages: [firstPage], pageParams: [undefined] },
    getNextPageParam: (lastPage) => lastPage.next_token ?? undefined,
    staleTime: Infinity,
  });
}
